import { render } from "./share.vue?vue&type=template&id=66ce40aa"
const script = {}
script.render = render

export default script